import { DateTime } from 'luxon';

import { ApjLicenseLabel } from 'commons/enums';
import { ICompanyInfo, OrderType, STODocument } from 'commons/types';
import {
  IRenderedSTOItem,
  ISTOSuratPesananMappedData,
} from 'pages/sto-print-template/surat-pesanan-template/interfaces';

import { numberToWords } from './numberToWords.util';

const TABLE_CHUNK = 12;
const NEXT_PAGE_TABLE_CHUNK = 19;

export const mapSTOSuratPesananPrintData = (
  stoDocument: STODocument,
  fromWarehouse: ICompanyInfo | null,
  toWarehouse: ICompanyInfo | null,
  tableChunk: number = TABLE_CHUNK,
  nextPageTableChunk: number = NEXT_PAGE_TABLE_CHUNK,
): ISTOSuratPesananMappedData => {
  const tableData: IRenderedSTOItem[][] = [];
  const items =
    stoDocument.items?.map((item) => {
      return {
        sku_code: item.sku_code,
        name: item.name,
        dosage_form: item.dosage_form || '',
        core_molecule: item.core_molecule || '',
        uom: item.uom || '',
        quantity: item.quantity.toString(),
        quantity_in_words: numberToWords(item.quantity),
      };
    }) || [];
  let tableChunkSize = tableChunk;
  for (let i = 0; i < items.length; i += tableChunkSize) {
    tableChunkSize = tableData.length >= 1 ? nextPageTableChunk : tableChunk;
    const chunk = items.slice(i, i + tableChunkSize);
    tableData.push(chunk);
  }

  const apjOrderType = stoDocument.is_alkes
    ? OrderType.ALKES
    : stoDocument.is_oot
    ? OrderType.OOT
    : stoDocument.is_prekursor
    ? OrderType.PRECURSOR
    : OrderType.REGULAR;
  const apjData = toWarehouse?.apj[apjOrderType];

  return {
    sto_number: stoDocument.sto_number || '',
    createdAt: DateTime.fromISO(
      stoDocument.createdAt as unknown as string,
    ).toFormat('dd-MMM-yyyy'),
    items: tableData,
    is_alkes: stoDocument.is_alkes,
    is_oot: stoDocument.is_oot,
    is_prekursor: stoDocument.is_prekursor,
    from_warehouse_info: fromWarehouse && {
      name: fromWarehouse.name,
      address: fromWarehouse.address,
      phone: fromWarehouse.phone || '',
    },
    to_warehouse_info: toWarehouse && {
      name: toWarehouse.name,
      address: toWarehouse.address,
      city: toWarehouse.city || '',
      phone: toWarehouse.phone || '',
      npwp: toWarehouse.npwp || '',
      npwp_address: toWarehouse.npwp_address || '',
      pbf_no: toWarehouse.pbf_no,
      dak_no: toWarehouse.dak_no,
      cdob_no: toWarehouse.cdob_no,
      cdakb_no: toWarehouse.cdakb_no,
      cdob_ccp_no: toWarehouse.cdob_ccp_no || '',
      apj_title: stoDocument.is_alkes
        ? 'Penanggung Jawab Teknis'
        : 'Apoteker Penanggung Jawab',
      apj_signature: apjData?.stamped_signature || '',
      apj_name: apjData?.name || '',
      apj_sipa: apjData?.sipa || '',
      apj_license_label: stoDocument.is_alkes
        ? ApjLicenseLabel.IJAZAH
        : ApjLicenseLabel.STRA,
    },
  };
};
